import React from 'react';
import PropTypes from 'prop-types';
import Bem from 'bemHelper';
import apiDecorator from 'api/api-decorator';
import { reportError } from 'api/api-errors';
import { emit } from 'helpers/global-events';
import map from 'lodash/map';
import { AutocompleteInput } from 'containers/form';
import Button, { btnThemes } from 'components/button';
import { iconTypes } from 'components/icon';
import Notification from 'components/notification';
import Row, { Col } from 'components/row';
import Hint from 'components/hint';

const classesBemForm = new Bem('modalContentAdmin');

@apiDecorator
export default class MovePostContent extends React.PureComponent {
  static propTypes = {
    className: PropTypes.string,
    onResetSelection: PropTypes.func,
    selectedItems: PropTypes.arrayOf(PropTypes.shape({}))
  };

  static contextTypes = {
    close: PropTypes.func.isRequired
  };

  constructor(...args) {
    super(...args);
    this.onInputChange = this.onInputChange.bind(this);
    this.movePosts = this.movePosts.bind(this);
    this.state = {
      searchValue: null
    };
  }

  onInputChange(val) {
    this.setState({
      searchValue: val
    });
  }

  /**
   * Move selected posts to other topic in DB.
   *
   * @param selectedItems
   */
  movePosts(selectedItems) {
    const topic_id = this.state.searchValue;

    if (topic_id) {
      this.api.post('action/forum/actions-move-posts/move', {
        postData: {
          posts: map(selectedItems, item => item.id),
          topic_id
        }
      })
        .then(() => this.afterMovePosts(selectedItems))
        .catch(error => reportError(error));

      this.setState({
        searchValue: null
      });
    }
  }

  // Call after success change author.
  afterMovePosts(selectedItems = []) {
    if (this.context && this.context.close) this.context.close();

    // Reset selected posts state.
    this.props.onResetSelection(false, selectedItems);
    if (this.state.searchValue) this.setState({ searchValue: null });

    Notification.success('Сообщения успешно перенесены.');

    // Make reload data provider club posts.
    emit('updateClubPosts');

    // Make reload data provider for TopicInfo and posts.
    emit('updatePosts');
  }

  render() {
    const { className, selectedItems } = this.props;

    return (
      <div {...classesBemForm({ extra: className })}>
        <div style={{ paddingBottom: '2.5rem' }}>
          <Hint text="Внимание! Все сообщения будут перенесены в указанную тему, кроме первого сообщения!" />
        </div>
        <div {...classesBemForm('autocompleteInput')}>
          <AutocompleteInput
            schema={{
              class: 'RuleString',
              label: 'Поиск по id темы (точное совпадение)',
              placeholder: ''
            }}
            url="forum/topic-list"
            onChange={this.onInputChange}
            value={this.state.searchValue}
            minLength={0}
            dictValue="topic_title"
            dictKey="topic_id"
            queryWord="search"
            noError
          />
        </div>
        <div {...classesBemForm('footer')}>
          <Row allAuto allJustifyCFlexEnd {...classesBemForm('btnsContainer')}>
            <Col allPr={0} allPl={20} mdPt={90}>
              <Button
                onClick={() => this.movePosts(selectedItems)}
                label="Перенести сообщения"
                iconType={iconTypes.edit}
                theme={btnThemes.sky}
                contentLeft
                big
              />
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}
